"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLTimeElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLTimeElementImpl
};
